import axios from "axios";

export const RequestType = {
  Post: "post",
  Get: "get",
  Delete: "delete",
  Put: "put",
  Patch: "patch",
};

const header = ({ auth = false, formData }) => {
  let headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": formData ? "multipart/form-data" : "application/json",
  };
  if (auth) {
    const token = localStorage.getItem("fms-maintenance-token");
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const apiMethod = async ({
  url,
  body,
  onSuccess,
  onFailure,
  auth,
  formData = true,
  method,
  params = {},
}) => {
  try {
    const response = await axios({
      method,
      url,
      data: body,
      headers: header({ auth, formData }),
      timeout: 15000, // 15 second timeout
    });

    if (onSuccess) onSuccess(response?.data);
    return response?.data;
  } catch (error) {
    let errorMessage = "An unexpected error occurred";

    // Handle network/connection errors
    if (error.code === "ECONNABORTED") {
      errorMessage = "Request timed out. Please check your connection.";
    } else if (!error.response) {
      errorMessage = "Network error. Please check your connection.";
    } else {
      // Handle API response errors
      errorMessage = Array.isArray(error?.response?.data?.message)
        ? error?.response?.data?.message[0]
        : error?.response?.data?.message || errorMessage;

      if (error.response?.status === 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }

    if (onFailure) onFailure(errorMessage);
  }
};
